var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPresale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8259 11.2583C10.9278 11.425 10.9874 11.62 10.9982 11.8222C11.009 12.0244 10.9707 12.226 10.8874 12.4054C10.8041 12.5848 10.6789 12.735 10.5254 12.8398C10.372 12.9446 10.1961 13 10.0167 13H5.98328C5.80395 13 5.62802 12.9446 5.47456 12.8398C5.32109 12.735 5.19592 12.5848 5.11259 12.4054C5.02927 12.226 4.99095 12.0244 5.0018 11.8222C5.01265 11.62 5.07224 11.425 5.17414 11.2583L6.52402 9.03949C6.9125 8.40094 6.9125 7.59906 6.52402 6.96051L5.17414 4.74167C5.07224 4.57498 5.01265 4.38 5.0018 4.17782C4.99095 3.97564 5.02927 3.77395 5.11259 3.59459C5.19592 3.41523 5.32109 3.26502 5.47456 3.16022C5.62802 3.05542 5.80395 3.00001 5.98328 3H10.0167C10.1961 3.00001 10.372 3.05542 10.5254 3.16022C10.6789 3.26502 10.8041 3.41523 10.8874 3.59459C10.9707 3.77395 11.009 3.97564 10.9982 4.17782C10.9874 4.38 10.9278 4.57498 10.8259 4.74167L9.47598 6.96051C9.0875 7.59906 9.0875 8.40094 9.47598 9.03949L10.8259 11.2583Z",
    fill: "url(#paint0_linear_14_12328)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_14_12328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8259 10.2583C11.9278 10.425 11.9874 10.62 11.9982 10.8222C12.009 11.0244 11.9707 11.226 11.8874 11.4054C11.8041 11.5848 11.6789 11.735 11.5254 11.8398C11.372 11.9446 11.1961 12 11.0167 12H6.98328C6.80395 12 6.62802 11.9446 6.47456 11.8398C6.32109 11.735 6.19592 11.5848 6.11259 11.4054C6.02927 11.226 5.99095 11.0244 6.0018 10.8222C6.01265 10.62 6.07224 10.425 6.17414 10.2583L7.52402 8.03949C7.9125 7.40094 7.9125 6.59906 7.52402 5.96051L6.17414 3.74167C6.07224 3.57498 6.01265 3.38 6.0018 3.17782C5.99095 2.97564 6.02927 2.77395 6.11259 2.59459C6.19592 2.41523 6.32109 2.26502 6.47456 2.16022C6.62802 2.05542 6.80395 2.00001 6.98328 2H11.0167C11.1961 2.00001 11.372 2.05542 11.5254 2.16022C11.6789 2.26502 11.8041 2.41523 11.8874 2.59459C11.9707 2.77395 12.009 2.97564 11.9982 3.17782C11.9874 3.38 11.9278 3.57498 11.8259 3.74167L10.476 5.96051C10.0875 6.59906 10.0875 7.40094 10.476 8.03949L11.8259 10.2583Z",
    fill: "white",
    fillOpacity: 0.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_14_12328",
    x: 4.1,
    y: 0.1,
    width: 9.8,
    height: 13.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.95
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_14_12328"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_14_12328",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14_12328",
    x1: 11.5,
    y1: 3,
    x2: 5,
    y2: 13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFD3F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7FF96"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresale);
export default __webpack_public_path__ + "static/media/presale.c4c6df3759bde30d828a274b78e34bbf.svg";
export { ForwardRef as ReactComponent };